import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ADPConfigService, ADPHeaderFactoryService, ADPResourceService } from 'digital-core';
import { HeaderDetail } from 'src/app/model/HeaderDetail';

@Injectable({
  providedIn: 'root'
})
export class PGHAPIService {
  constructor(
    private resourceService: ADPResourceService,
    private http: HttpClient,
    private headerService: ADPHeaderFactoryService,
    private configService: ADPConfigService
  ) {}

  public getAuthorizationHeaderOptions() {
    const secureHttpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json',
      })
    };
    return secureHttpOptions;
  }

  post<T, Y>(urlKey: string, entity: T): Observable<Y> {
    let endpoint = urlKey;
    if (urlKey.toLowerCase().indexOf('url_') === 0) {
      endpoint = this.resourceService.getPortalSetting(urlKey).Value;
    }

    if (!endpoint.startsWith('http')) {
       endpoint = `${this.configService.cmsApiUrl}/${endpoint}`;
    }
    return this.http.post<Y>(
      endpoint,
      entity
    );
  }

  postWithCustomHeaders<T, Y>(urlKey: string, entity: T, customHeaders: HeaderDetail[]): Observable<Y> {
    let endpoint = urlKey;
    if (urlKey.toLowerCase().indexOf('url_') === 0) {
      endpoint = this.resourceService.getPortalSetting(urlKey).Value;
    }
    const headers = this.getAuthorizationHeaderOptions();

    customHeaders.forEach((customHeader) => {
      if (headers.headers.keys().includes(customHeader.headerId)) {
        headers.headers = headers.headers.delete(customHeader.headerId);
      }
      headers.headers = headers.headers.append(
        customHeader.headerId,
        customHeader.headerValue
      );
    });
    return this.http.post<Y>(`${this.configService.cmsApiUrl}/${endpoint}`, entity, { headers: headers.headers });
  }

  publicPost<T, Y>(urlKey: string, entity: T): Observable<Y> {
    let endpoint = urlKey;
    if (urlKey.toLowerCase().indexOf('url_') === 0) {
      endpoint = this.resourceService.getPortalSetting(urlKey).Value;
    }
    // const dotnetAPI = 'http://localhost:5000/api/v1.0';
    return this.http.post<Y>(
      `${this.configService.cmsApiUrl}/${endpoint}`,
   //   `${dotnetAPI}/${endpoint}`,
      entity,
      this.getAuthorizationHeaderOptions()
    );
  }

  publicPostWithHeaders<T, Y>(urlKey: string, entity: T, customHeaders: HeaderDetail[]): Observable<Y> {
    let endpoint = urlKey;
    if (urlKey.toLowerCase().indexOf('url_') === 0) {
      endpoint = this.resourceService.getPortalSetting(urlKey).Value;
    }
    const headers = this.getAuthorizationHeaderOptions();

    customHeaders.forEach((customHeader) => {
      if (headers.headers.keys().includes(customHeader.headerId)) {
        headers.headers = headers.headers.delete(customHeader.headerId);
      }
      headers.headers = headers.headers.append(
        customHeader.headerId,
        customHeader.headerValue
      );
    });
    return this.http.post<Y>(
      `${this.configService.cmsApiUrl}/${endpoint}`,
      entity,
      { headers: headers.headers });
  }

  get<Y>(urlKey: string, query: string): Observable<Y> {
    let endpoint = urlKey;
    if (urlKey.toLowerCase().indexOf('url_') === 0) {
      endpoint = this.resourceService.getPortalSetting(urlKey).Value;
    }
    if (query) {
      endpoint += query;
    }
    return this.http.get<Y>(
      `${this.configService.cmsApiUrl}/${endpoint}`,
      this.getAuthorizationHeaderOptions()
    );
  }

  getWithCustomHeaders<Y>(urlKey: string, customHeaders: HeaderDetail[]): Observable<Y> {
    let endpoint = urlKey;
    if (urlKey.toLowerCase().indexOf('url_') === 0) {
      endpoint = this.resourceService.getPortalSetting(urlKey).Value;
    }
    const headers = this.getAuthorizationHeaderOptions();

    customHeaders.forEach((customHeader) => {
      if (headers.headers.keys().includes(customHeader.headerId)) {
        headers.headers = headers.headers.delete(customHeader.headerId);
      }
      headers.headers = headers.headers.append(
        customHeader.headerId,
        customHeader.headerValue
      );
    });
    return this.http.get<Y>(`${this.configService.cmsApiUrl}/${endpoint}`, { headers: headers.headers });
  }

  getDocument<Y>(urlKey: string, query: string): Observable<Y> {
    let endpoint = urlKey;
    if (urlKey.toLowerCase().indexOf('url_') === 0) {
      endpoint = this.resourceService.getPortalSetting(urlKey).Value;
    }
    if (query) {
      endpoint += query;
    }
    // console.log('We are here');
    return this.http.get<Y>(
      //  `http://localhost:5000/api/v1.0/${endpoint}`,
      `${this.configService.cmsApiUrl}/${endpoint}`,
      this.getAuthorizationHeaderOptions()
    ).pipe(catchError(this.parseErrorBlob));
  }

  parseErrorBlob(err: HttpErrorResponse): Observable<any> {
    const reader: FileReader = new FileReader();
    const obs = Observable.create((observer: any) => {
      reader.onloadend = (e) => {
        const errorMessage = JSON.parse(reader.result as string);
        observer.error(
          new HttpErrorResponse({
            error: errorMessage,
            headers: err.headers,
            status: err.status,
            statusText: err.statusText,
            url: err.url,
          })
        );
        observer.complete();
      };
    });
    reader.readAsText(err.error);
    return obs;
  }
}
